export const DEFAULT_ROUTE = '/claims/dashboard';